import { Trans } from 'react-i18next';
import { Nav, Tab } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import MainBlockLayout from '../../components/MainBlockLayout';
import { PTA_GALLERY_YEARS } from '../../data/PTAImagesData';
import { generateImageTabs } from '../../utils/common';
import React, { useState } from 'react';
import './ParentsCommittee.css';

function MainBlock() {
  const [loading, setLoading] = useState(true);
  // Gallery years come from data/PTAImagesData.js (add a year there to add a tab)
  const yearEntries = Object.entries(PTA_GALLERY_YEARS);
  const defaultYear = yearEntries[0]?.[0];

  return (
    <div className="ptaPage">
      <div className="ptaHero">
        <h2><Trans i18nKey="parents committee" /></h2>
      </div>

      {/* The text is HTML from the translation file (key: "pta main text") */}
      <div className="ptaIntro">
        <Trans i18nKey="pta main text" />
      </div>

      <div className="ptaJoin">
        <p><Trans i18nKey="pta_join" /></p>
        <Link className="ptaJoinButton" to="/contact-us"><Trans i18nKey="Contact Us" /></Link>
      </div>

      <h3 className="ptaEventsTitle"><Trans i18nKey="our events" /></h3>
      <Tab.Container id="pta-years" defaultActiveKey={defaultYear}>
        <Nav variant="pills" className="ptaYears">
          {yearEntries.map(([year]) => (
            <Nav.Item key={year}>
              <Nav.Link eventKey={year} onClick={() => setLoading(true)}>{year}</Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
        <div className="ptaGalleryBox">
          <Tab.Content>
            {yearEntries.map(([year, gallery]) => (
              <Tab.Pane key={year} eventKey={year}>
                <div className="pta-gallery">
                  {generateImageTabs(gallery.pta, loading, setLoading, 'bottom')}
                </div>
              </Tab.Pane>
            ))}
          </Tab.Content>
        </div>
      </Tab.Container>
    </div>
  );
}

export default MainBlockLayout(MainBlock);
